module.exports = __webpack_public_path__ + "static/img/fil.95ff5709.png";